import React, { useEffect, useState } from "react"
import { Container, UncontrolledDropdown, DropdownToggle, DropdownMenu, Form, Input, Label } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import sideImg from "../../../assets/images/profile-img.png"
import India from "../../../assets/images/flags/india.png"
import Uk from "../../../assets/images/flags/uk.png"
import ReactSelect from "react-select"
import Select from "react-select"
import TDSInvoice from "../../../assets/images/TDSInvoice.jpg"

import "../../../assets/css/Finance/Style/TDS/style.css"



import addvendorpay from "../../../assets/images/Expenses/addExpense.jpg"
// import addExpense from "../../../assets/images/Expenses/addExpense.jpg";
import uploadbill from "../../../assets/images/Expenses/Upload_Bill.jpg";
import viewbill from "../../../assets/images/Expenses/View_Bill.jpg";
// import paymentdone from "../../../assets/images/Expenses/payment.jpg";

import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { CSVLink } from "react-csv"

import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
// import InfoGif from "../../../assets/images/GIF/question-mark.gif"



// common component
import Pagination from "components/Common/Pagination"

// components
// import ViewProfile from "./ViewIntroducer/ViewProfile"
// import ViewActivity from "./ViewIntroducer/ViewActivity"
// import ViewNotes from "./ViewIntroducer/ViewNotes"

// Hover card
import ProfileDetails from "components/Common/ProfileDetails"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import swal from "sweetalert"
// import ViewFiles from "./ViewIntroducer/ViewFiles"
// import ViewPayment from "./ViewIntroducer/ViewPayment"
import configure from "configure"
import Swal from "sweetalert2"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import indiaFlag from "../../../assets/images/flags/uk.png"
import ukFlag from "../../../assets/images/flags/india.png"
import MonthPicker from "components/Common/MonthPicker"

function TableContainer({ columns, data, setAccessDenied, setLoading }) {
  const [fixedContent, setFixedContent] = useState(false)
  const [status, setStatus] = useState(false)
  const [fixButtons, setFixButtons] = useState(false)
  const [formRows, setFormRows] = useState([{}])
  const [formPopup, setFormPopup] = useState(false)

  const [modal_fullscreen, setmodal_fullscreen] = useState(false)

  const [uploadBill, setUploadBill] = useState(false)
  const [viewBill, setViewBill] = useState(false)

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const excelColumns = []
  columns.forEach(column => {
    column.Header !== "Action" && excelColumns.push(column.Header)
  })

  const csvData = [
    excelColumns,
    ...data.map(
      ({
        id,
        date,
        title,
        invoiceNo,
        customer,
        tdsReceive,
        category,
        debit,
        credit,
      }) => [
        id,
        date,
        title,
        invoiceNo,
        customer,
        tdsReceive,
        category,
        debit,
        credit,
      ]
    ),
  ]
  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  const [title, setTitle] = useState("")
  const [name_modal, setNameModal] = useState(false)
  // const [addExpense, setAddExpense] = useState(false)

  const info = [
    {
      title: "Assigned",
      mean: " <p> <strong>Meaning :</strong> In the Mars System's Introducer Module, the <strong>Assigned</strong> column designates the specific team member or individual responsible for managing the relationship and interactions with the introducer who connects your company with potential clients.</p>",
      purpose:
        " <p> <strong>Purpose :</strong> The purpose of the <strong>Assigned</strong>  column is to ensure that there is clear accountability for maintaining and nurturing the relationship with the introducer. It helps streamline communication, track progress, and ensure that introducers are well-supported and informed about your company's services. This column fosters effective introducer management, enhancing the chances of successful client referrals and maintaining a strong network of introducers within the Mars System's framework.</p>",
    },
    {
      title: "Name",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Introducer Module, the  <strong>Name</strong> column represents the full name of the individual or business entity associated with the introducer who has connected your company with potential clients.</p>",
      purpose:
        "<p> <strong>Purpose :</strong> The purpose of the <strong>Name</strong> column is to provide specific identification of the introducer. It allows for personalized communication and relationship-building with the introducer, which can be essential in maintaining a strong partnership. Knowing the introducer's name ensures that interactions are respectful and tailored, fostering trust and collaboration within the Mars System's context.</p>",
    },
    {
      title: "Email ID",
      mean: "<p><strong>Meaning :</strong>  Within the Mars System's Introducer Module, the  <strong>Email ID</strong> column stores the email addresses of individuals or businesses who act as introducers, facilitating connections between clients and your company's services.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Email ID</strong>  column is to provide a direct and reliable means of communication with the introducer. Email addresses enable efficient correspondence, updates, and collaboration with introducers. This column ensures that your company can maintain open channels of communication, share important information, and coordinate effectively with introducers who play a vital role in connecting clients with your services within the Mars System's framework.</p>",
    },
    {
      title: "Phone",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Introducer Module, the <strong>Phone</strong> column contains the contact phone numbers of the individuals or businesses who serve as introducers, facilitating connections between clients and your company's services.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Phone</strong> column is to provide an additional communication channel with the introducers. Phone numbers enable your team to engage in voice calls and real-time conversations, which can be particularly valuable for discussing potential client opportunities and coordination. This column ensures that there is a versatile means of contacting and collaborating with introducers within the Mars System's framework, ultimately enhancing the efficiency of your introducer network.</p>",
    },
    {
      title: "Days",
      mean: " <p><strong>Meaning :</strong>  In the Mars System's Introducer Module, the <strong>Days</strong>  column represents the number of days that have elapsed since the last update or interaction with the introducer, or since the introducer facilitated a connection with a client.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Days</strong> column is to provide a time-based reference for the activity and engagement level with introducers. It helps in tracking the recency of interactions, ensuring that introducers are regularly engaged and updated about client referrals. This column assists in prioritizing introducers who require follow-ups or additional support, ensuring that your introducer network remains active and productive within the Mars System's context.</p>",
    },
    {
      title: "Status",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Introducer Module, the <strong>Status</strong> column indicates the current status or stage of the relationship and engagement with the introducer.</p>",
      purpose:
        "<p><strong>Purpose :</strong>  The purpose of the  <strong>Status</strong> column is to provide a clear overview of the state of your interactions with the introducer. It allows you to categorize introducers into stages such as <strong>New </strong> ,  <strong>In-Process </strong>,  <strong>Needs Follow-up </strong>,  or  <strong>Converted to Introducer</strong>.  This status tracking helps in managing and prioritizing introducer relationships effectively. It ensures that introducers receive the appropriate level of attention and support within the Mars System's framework, facilitating mutually beneficial partnerships and successful client referrals.</p>",
    },
  ]

  const onAddPermission = async id => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", 24)
    try {
      await axios({
        method: "post",
        url: `${configure.nodeApi}/user_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(res => {
        if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
          navigate(`${configure.appUrl}sales/add-introducer`)

        } else {
          setAccessDenied(true)
        }
        setLoading(false)
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  
  const customer = [
    { label: "Gujarat", value: "1" },
    { label: "Zithas", value: "2" },
    { label: "jinal", value: "3" },
  ]
  const invoice_type = [
    { label: "Zithas Invoice", value: "1" },
    { label: "Zithas Invoice", value: "2" },
    { label: "Zithas Invoice", value: "3" },
  ]
  const location = [
    { label: "India", value: "1" },
    { label: "UK", value: "2" },
  ]

  const payments = [
    { label: "Bank Account", value: "1" },
    { label: "Credit Card", value: "2" },
    { label: "Other", value: "3" },
  ]

  const projects =[
    { label: "Earth Development", value: "1" },
    { label: "Mars Development", value: "2" },
    { label: "Jen Therapy", value: "3" }
  ]

  const currency = [
    { label: "AUD", value: "1" },
    { label: "INR", value: "2" },
    { label: "USD", value: "3" },
    { label: "AED", value: "4" }
  ]
  const discount_type = [
    { label: "Percentage %", value: "1" },
    { label: "Fixed", value: "2" },
  ]
  const terms = [
    { label: "Due on Receipt", value: "1" },
    { label: "Due in 15 days", value: "2" },
  ]


  const [addVendorPay, setAddVendorPay] = useState(false)

  // Render the UI for your table
  return (
    <div>
   <Row className="mb-2">
        {/* Amounts Records */}
        <div className="d-flex mb-4">
          <a href="#" className="rounded payment-amounts mb-0 text-success">
            <p className="mb-2">Current Month Balance </p>
            <h4 className="">₹ 0.00</h4>
          </a>

          <a href="#" className="rounded payment-amounts mb-0 text-info">
            <p className=" mb-2">Current Year Balance </p>
            <h4 className="">₹ 100.00</h4>
          </a>

          <a href="#" className="rounded payment-amounts mb-0 text-warning">
            <p className=" mb-2">Previous Year Balance </p>
            <h4 className="">₹ 220.00</h4>
          </a>
        </div>
        <Col>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <button
              onClick={() => setFormPopup(!formPopup)}
              className="btn btn-outline-secondary border-radius me-2"
            >
              <i className="fas fa-filter"></i>
            </button>
            {/* CSV download btn */}
            <CSVLink
              className="border-radius btn text-white me-2 btn-success btn-label"
              filename="tds_zithas.csv"
              data={csvData}
            >
              <i className="fas fa-download me-2 icon-size label-icon"></i>{" "}
              Export CSV
            </CSVLink>
            <button
                onClick={() => navigate(-1)}
                className="border-radius btn btn-red btn-label"
            >
                <i className="dripicons-cross me-2  label-icon icon-center"></i>
                CANCEL
            </button>
          </div>
        </Col>
      </Row>

      <div className="position-relative">
        <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${
              fixedContent ? "fix-header" : ""
            } fix-introducer-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <a
                        onClick={() => {
                          setNameModal(true)
                          setTitle(column.Header)
                        }}
                      >
                        {/* <i
                          title="info"
                          className="bx bx-info-circle ms-1 info-icon"
                        ></i> */}
                      </a>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr className="row-hover" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${
                          cell.column.className
                        }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>
      {formPopup ? (
          <div className="p-4" id="tds_filter_popup">
            <Form>
              <Row className="align-items-end">
                <div className="col-md-3">
                  <label htmlFor="">Start Date</label>
                  <input type="date" className="form-control " />
                </div>

                <div className="col-md-3">
                  <label htmlFor="">End Date</label>
                  <input type="date" className="form-control " />
                </div>

                <div className="col-md-3">
                  <label htmlFor="">By</label>
                  <select type="date" className="form-select ">
                    <option value="Nothing Selected">Nothing Selected</option>
                    <option value="Debit">Debit</option>
                    <option value="Credit">Credit</option>
                  </select>
                </div>

                <div className="text-center col-md-3">
                  <button className="btn border-radius btn-purple me-3">
                    <i className="fas fa-search me-2"></i>
                    Search
                  </button>
                  <button
                    className="btn border-radius btn-red"
                    onClick={e => {
                      e.preventDefault()
                      setFormPopup(!formPopup)
                    }}
                  >
                    <i className="dripicons-cross me-1 icon-center"></i> Clear
                  </button>
                </div>
              </Row>
            </Form>
            <i className="bi bi-triangle-fill pop-icon"></i>
          </div>
        ) : null}

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>

     
    </div>
  )
}

const ZithasTdsPage = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const [tdsReceiveModal, setTdsReceiveModal] = useState(false)




  const colourStyles = {
    control: (styles , state) => ({
      ...styles,
      backgroundColor: state.isDisabled ? "gray" : "white",
      // other styles
    }),
    // other style properties
  };

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setmodal_fullscreen(false)
  })

  //meta title
  document.title = "Zithas Invoice | Zithas Crm"

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setmodal_fullscreen(false)
  })

  const [data, setDatas] = useState([])
  const [view_customer, setVeiwCustomer] = useState([])
  const [isLoading, setLoading] = useState(false)
  const[paymentMode, setPaymentMode] = useState(false)

 

  const [fixButtons, setFixButtons] = useState(false)
  const [formRows, setFormRows] = useState([{}])

  const [modal_Access, setAccessDenied] = useState(false)
  useEffect(() => {
    fetch()
  }, [])

  const fetch = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/introducer`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        setDatas(response.data.data)
        setLoading(false)
      })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const DeleteModal = () => {
    Swal.fire({
      icon: "warning",
      text: "Are you sure want to delete?",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(willOkay => {
      if (willOkay.isConfirmed) {
        Swal.fire({
          icon: "success",
          text: "Data deleted successfully",
        })
      }
    })
  }


  const navigate = useNavigate()

  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center tds-col-1",
      },
      {
        Header: "Date",
        accessor: "date",
        isInfoIcon: true,
        className : "text-center tds-col-2"
      },
      {
        Header: "Title",
        accessor: "title",
        isInfoIcon: true,
        className : "tds-col-3"

      },
      {
        Header: "Invoice No",
        accessor: "invoiceNo",
        isInfoIcon: true,
        className: "text-center tds-col-4",
      },
      {
        Header: "Customer",
        accessor: "customer",
        isInfoIcon: true,
        className: "tds-col-5",
      },
      {
        Header: "Category",
        accessor: "category",
        isInfoIcon: true,
        className: "tds-col-6",
      },
      {
        Header: "TDS Receive",
        accessor: "tdsReceive",
        isInfoIcon: true,
        className: "text-center tds-col-7",
      },
      {
        Header: "Debit(-)",
        accessor: "debit",
        isInfoIcon: true,
        className: "text-center tds-col-8",
      },
      {
        Header: "Credit(+)",
        accessor: "credit",
        isInfoIcon: true,
        className: "text-center tds-col-9",
      },
      {
        Header: "Action",
        accessor: "action",
        className: "text-center tds-col-10",
        Cell: cellProps => {
          return (
            <div>
              <button
                onClick={() => setTdsReceiveModal(true)}
                title="TDS Receive"
                className="btn btn-sm btn-outline-secondary"
              >
                <i className="fas fa-pager fs-5"></i>
              </button>
            </div>
          )
        },
      },
    ],
    []
  )


  const customer = [
    { label: "Gujarat", value: "1" },
    { label: "Zithas", value: "2" },
    { label: "jinal", value: "3" },
  ]
  const invoice_type = [
    { label: "Zithas Invoice", value: "1" },
    { label: "Zithas Invoice", value: "2" },
    { label: "Zithas Invoice", value: "3" },
  ]
  const location = [
    { label: "India", value: "1" },
    { label: "UK", value: "2" },
  ]

  const payments = [
    { label: "Bank Account", value: "1" },
    { label: "Credit Card", value: "2" },
    { label: "Other", value: "3" },
  ]

  const projects =[
    { label: "Earth Development", value: "1" },
    { label: "Mars Development", value: "2" },
    { label: "Jen Therapy", value: "3" }
  ]

  const currency = [
    { label: "AUD", value: "1" },
    { label: "INR", value: "2" },
    { label: "USD", value: "3" },
    { label: "AED", value: "4" }
  ]
  const discount_type = [
    { label: "Percentage %", value: "1" },
    { label: "Fixed", value: "2" },
  ]
  const terms = [
    { label: "Due on Receipt", value: "1" },
    { label: "Due in 15 days", value: "2" },
  ]

  const data2 = [
    {
      id: 1,
      category: "Phone Bill",
      invoiceNo: "2022-2023/TSG/00010",
      customer: "Zithas Technologies",
      tdsReceive: "28-06-2024",
      date: "28-06-2024",
      title: "Web Development",
      debit: 1000,
      credit: 2000,
    },
    {
      id: 2,
      category: "Phone Bill",
      invoiceNo: "2022-2023/TSG/00010",
      customer: "Zithas Technologies",
      tdsReceive: "28-06-2024",
      date: "28-06-2024",
      title: "Web Development",
      debit: 1000,
      credit: 2000,
    },
    {
      id: 3,
      category: "Phone Bill",
      invoiceNo: "2022-2023/TSG/00010",
      customer: "Zithas Technologies",
      tdsReceive: "28-06-2024",
      date: "28-06-2024",
      title: "Web Development",
      debit: 1000,
      credit: 2000,
    },
    {
      id: 4,
      category: "Phone Bill",
      invoiceNo: "2022-2023/TSG/00010",
      customer: "Zithas Technologies",
      tdsReceive: "28-06-2024",
      date: "28-06-2024",
      title: "Web Development",
      debit: 1000,
      credit: 2000,
    },
    {
      id: 5,
      category: "Phone Bill",
      invoiceNo: "2022-2023/TSG/00010",
      customer: "Zithas Technologies",
      tdsReceive: "28-06-2024",
      date: "28-06-2024",
      title: "Web Development",
      debit: 1000,
      credit: 2000,
    },
    {
      id: 6,
      category: "Phone Bill",
      invoiceNo: "2022-2023/TSG/00010",
      customer: "Zithas Technologies",
      tdsReceive: "28-06-2024",
      date: "28-06-2024",
      title: "Web Development",
      debit: 1000,
      credit: 2000,
    },
    {
      id: 4,
      category: "Phone Bill",
      invoiceNo: "2022-2023/TSG/00010",
      customer: "Zithas Technologies",
      tdsReceive: "28-06-2024",
      date: "28-06-2024",
      title: "Web Development",
      debit: 1000,
      credit: 2000,
    },
    {
      id: 5,
      category: "Phone Bill",
      invoiceNo: "2022-2023/TSG/00010",
      customer: "Zithas Technologies",
      tdsReceive: "28-06-2024",
      date: "28-06-2024",
      title: "Web Development",
      debit: 1000,
      credit: 2000,
    },
    {
      id: 6,
      category: "Phone Bill",
      invoiceNo: "2022-2023/TSG/00010",
      customer: "Zithas Technologies",
      tdsReceive: "28-06-2024",
      date: "28-06-2024",
      title: "Web Development",
      debit: 1000,
      credit: 2000,
    },
  ]

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Zithas"} />

          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data2}
                      setAccessDenied={setAccessDenied}
                      setLoading={setLoading}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>             
        
        {/* Modal  */}
      <Modal isOpen={tdsReceiveModal} size="lg" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">TDS Receive</h5>
          <button
            type="button"
            onClick={() => {
              setTdsReceiveModal(false)
            }}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form>
            <Row className="d-flex justify-space-arround align-items-center gap-4">
                <div className="col-md-5 d-flex justify-content-end align-items-center ps-3 ">
                  <div className="text-center">
                    <img src={TDSInvoice} alt="Addepe" style={{width : "90%"}} />
                  </div>
                </div>
                <div className="col-md-6 d-flex flex-column justify-content-center align-items-start">
                <div className="mb-3 ps-2">
                    <h5>TDS Records</h5>
                </div>
                <div className="col-md-12  ps-2 mb-4 d-flex">
                    {/* <div className="d-flex gap-4"> */}
                      
                        <div className="col-md-7">
                            <Label htmlFor="formrow-firstname-Input">Select Date <span className="text-danger">*</span></Label>                 
                            <div className="d-flex justify-content-start align-items-center gap-2">
                            <Input
                                type="date"
                                className="form-control"
                                placeholder="Select Date"
                            />  
                            </div>
                        </div>

                    
                </div>
                <div className="col-md-12  ps-2 mb-3 d-flex">
                    <div className="col-md-4">
                            <Label htmlFor="formrow-firstname-Input">Enter Amount <span className="text-danger">*</span></Label>                 
                            <div className="d-flex justify-content-start align-items-center gap-2">
                            <Input
                                type="text"
                                className="form-control"
                                placeholder="Amount"
                            />  
                            </div>
                    </div>
                </div>
                   
                </div>
            </Row>

            {/* <div className="border-bottom my-3"></div> */}
            <div className="text-end">
                <button className="btn btn-save btn-label me-2">
                    <i className="fas fa-save me-2 icon-size label-icon me-2"></i>
                    Submit
                </button>
            </div>
          </Form>
        </div>
      </Modal>
      

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default ZithasTdsPage
